import { render, staticRenderFns } from "./TheFormUsers.vue?vue&type=template&id=2ed47c13&scoped=true&"
import script from "./TheFormUsers.vue?vue&type=script&lang=ts&"
export * from "./TheFormUsers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed47c13",
  null
  
)

export default component.exports